export default "__VITE_ASSET__CLVuB4OB__"